import React from "react";

/**
 * Milestone A · Multi-tier pricing display for public workspace cards.
 * Reads either the modern `pricing` block (hourly / half-day / full-day)
 * or falls back to legacy `hourly` / `daily`. Renders only enabled tiers,
 * pipe-separated.
 */
export default function PriceTiers({ workspace, className = "m-card-price" }) {
  const p = workspace?.pricing || {};
  const tiers = [];

  if (p.hourly_enabled && p.hourly_rate) {
    tiers.push({ key: "hr", label: "per hour", price: p.hourly_rate });
  } else if (workspace?.hourly) {
    tiers.push({ key: "hr", label: "per hour", price: workspace.hourly });
  }

  if (p.half_day_enabled && p.half_day_rate) {
    const dur = p.half_day_duration_hours || 4;
    tiers.push({ key: "hd", label: `per ${dur}h half day`, price: p.half_day_rate });
  }

  if (p.full_day_enabled && p.full_day_rate) {
    tiers.push({ key: "fd", label: "per day", price: p.full_day_rate });
  } else if (workspace?.daily) {
    tiers.push({ key: "fd", label: "per day", price: workspace.daily });
  }

  if (tiers.length === 0) return null;

  return (
    <div className={className} data-testid={`price-tiers-${workspace?.workspace_id || workspace?.slug || "ws"}`}>
      {tiers.map((t, i) => (
        <React.Fragment key={t.key}>
          {i > 0 && <span className="sep">|</span>}
          <span data-testid={`price-tier-${t.key}`}>
            <em>${Number(t.price).toFixed(Number(t.price) % 1 === 0 ? 0 : 2)}</em>
            {t.label}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}
